












import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-edit',

})
export default class IEdit extends Vue {

  @Prop({type: [String], default: '#0A0A0A'}) protected color!: string
  @Prop({type: [Boolean], default: true}) protected isEdit!: boolean

}

